import { autoinject } from "aurelia-framework";
import { PartialInspectionLayoutModel } from "../../../models/rightship-inspections.models";
import { TitleConst } from "../../../constants/title.constaints";

@autoinject
export class InspectionClosed {

    public inspectionModel: PartialInspectionLayoutModel;
    public readonly title: string = TitleConst.ClosedProposal;

    constructor() {
    }
    
    activate(params: { vesselName: string, vesselImo: string, portName: string, country: string, requestedInspectionDate: string, invoiceNumber: string, encryptedData: string, rsInspectionId: string }) {

        this.inspectionModel = {
            vesselDetails: {
                vesselName: params.vesselName,
                vesselImo: params.vesselImo,
            },
            portAndOperationalDetails: {
                port: params.portName,
                country: params.country,
                requestedInspectionDate: params.requestedInspectionDate
            },
            rightShipInspectionId: params.rsInspectionId
        }
    }  
}